import { createContext, useContext, useEffect, useState } from "react";
import { useMakePairs } from "../../hooks/usePairsHook";
import { loadPersistedData } from "../../utils/persistor";
import PairHeader from "./PairHeader";
import PairTable from "./PairTable";
import Loading from "../common/loading/Loading"
import { PairsBox } from "../../styles/BoxingStyles"


const PairContext = createContext({
    filters: {}, setFilters: () => { }
})

export const usePairContext = () => {
    return useContext(PairContext)
}

const Pairs = () => {

    const starred = loadPersistedData("starred")
    const [filteredParis, setFilteredPairs] = useState()
    const [filters, setFilters] = useState({
        search: "", pair: null, starred: starred ? starred : []
    })

    const {
        onBoardPairs,
        loading,
        onSortClicked,
        onStarredChange
    } = useMakePairs({ filters, setFilters });

    useEffect(() => {
        if (onBoardPairs.length) {
            const validPairs = ["usdt-irt"];

            const filteredData = onBoardPairs.filter(item =>
                validPairs.includes(`${item.coin.toLowerCase()}-${item.pair.toLowerCase()}`)
            );
            setFilteredPairs(filteredData)
        }
    }, [onBoardPairs])


    return (
        <PairContext.Provider value={{ filters, setFilters }}>
            <PairsBox>
                <PairHeader onSortClicked={onSortClicked} />
                <PairTable pairs={filteredParis} onStarredChange={onStarredChange} />
                <Loading loading={loading} />
            </PairsBox>
        </PairContext.Provider>
    )
}


export default Pairs;
